import React, { Component } from "react";
import { connect } from "react-redux";
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import DeleteIcon from '@material-ui/icons/Delete';
import Modal from '@material-ui/core/Modal';
import TextField from "@material-ui/core/TextField";
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
// import ButtonGroup from "@material-ui/core/ButtonGroup";
import { addHeadSubhead, getHeadSubheadHierarchy, updateHeadAndSubhead } from '../../../actions/businessActions';
const styles = theme => ({
    header: {
        height: '20%',
        margin: '0px 0px',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        paddingLeft: "22px",
        backgroundColor: theme.palette.primary.main,
    },
    grid: {
        margin: '0px 0px',
        width: '100%',
        //display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        paddingLeft: "15px",
        paddingRight: "15px"
    },
    content: {
        height: '73%',
        // height: '60%',
        margin: '10px 0px',
        overflow: 'auto',
    },
    footer: {
        height: '10%',
        margin: '0px 0px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    headGridTwo: {
        float: 'right',
        marginRight: '2px'
    },
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '0px'
    },
    modalContainer: {
        width: '70vw',
        minWidth: 400,
        maxWidth: 900,
        height: '80vh',
        minHeight: 400,
        maxHeight: '90vh',
        backgroundColor: theme.palette.background.paper,
        padding: '24px 24px',
        margin: '10px 0px',
        overflowY: 'auto',
        overflowX: 'hidden',
        borderRadius: 8,
        boxShadow: theme.shadows[5],
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
    },
    tableCellSmall: {
        fontSize: "12px",
        padding: "6px 0px 6px 16px"
    },
    head: {
        fontWeight: 700,
        fontSize: "12px",
    }
});


class HeadDetailView extends Component {
    constructor(props) {
        super();
        this.state = {
            headName: "",
            sequenceNo: 1,
            error: "",
            headImage: "",
            allImage: "",
            headImageFile: null,
            allImageFile: null,
            uploading: false
        };
    }

    handleHeadImageChange = async (event) => {
        const file = event.target.files[0];
        if (!file) return;
        this.setState({ uploading: true });
        try {
            const data = new FormData();
            const folderPath = `Marketplace_Business/${this.props.businessDetails._id}/heads`;
            let temp = file.name.split(".");
            let fileName = temp[0] + Math.ceil(Math.random() * 999999) + "." + (temp[1] || "");
            data.append("file", file);
            data.append("folder", folderPath);
            data.append("public_id", `${this.props.businessDetails._id}/${fileName}`);
            data.append("upload_preset", this.props.env.cloudinaryBusinessImagesUploadPreset);
            const res = await fetch(this.props.env.cloudinaryUploadUrl, {
                method: "POST",
                body: data,
            });
            const uploaded = await res.json();
            if (uploaded.secure_url) {
                this.setState({ headImage: uploaded.secure_url, headImageFile: file });
            }
        } catch (err) {
            console.log(err);
        }
        this.setState({ uploading: false });
    };

    handleDeleteHeadImage = () => {
        this.setState({
            headImage: "",
            headImageFile: null
        });
    };

    handleIncrement = () => {
        let sequence = this.state.sequenceNo + 1;
        if (sequence <= (this.props.headsLength + 1)) {
            this.setState({ sequenceNo: sequence });
        }
    };

    handleDecrement = () => {
        if (this.state.sequenceNo && (this.state.sequenceNo > 1)) {
            this.setState(state => ({ sequenceNo: state.sequenceNo - 1 }));
        }
    };

    handleChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });

        if (!this.state.error) {
            this.setState({ error: "" })
        }
    }

    checkerror = () => {
        if (!this.state.headName || !this.state.headName.trim()) {
            this.setState({ error: "Required" })
        }
    }

    createHead = async () => {
        await this.checkerror();
        if (!this.state.error) {
            if (!this.props.edit) {
                let payload = {
                    name: this.state.headName,
                    type: "Head",
                    parentId: null,
                    children: [],
                    subcategory: null,
                    businessId: this.props.businessDetails._id,
                    services: [],
                    sequence: this.state.sequenceNo,
                    headImage: this.state.headImage,
                };
                await this.props.addHeadSubhead(payload);
                this.close();
                this.props.getHeadSubheads();
            } else if (this.props.edit) {
                let payload = {
                    data: {
                        name: this.state.headName,
                        headImage: this.state.headImage,
                    },
                    id: this.props.data._id
                };
                if (this.state.sequenceNo) {
                    payload.data.sequence = this.state.sequenceNo;
                }
                await this.props.updateHeadAndSubhead(payload);
                this.close();
                this.props.getHeadSubheads();
            }
        }
    };

    clearData = () => {
        this.setState({
            headName: "",
            sequenceNo: 1,
            error: "",
            headImage: "",
            headImageFile: null
        })
    }

    close = () => {
        this.clearData();
        this.props.onClose();
    }

    // componentDidUpdate(prevProps) {
    //     if (this.props.edit && (this.props.edit !== prevProps.edit) && this.props.data.name) {
    //         this.setState({
    //             headName: this.props.data.name,
    //             sequenceNo: this.props.data.sequence,
    //             headImage: this.props.data.headImage || "",
    //             allImage: this.props.data.allImage || ""
    //         });
    //     }
    //     if (!this.props.edit && this.props.open && !prevProps.open) {

    //         let allImage = "";

    //         // Only fetch previous All Image if at least 1 head exists
    //         if (Array.isArray(this.props.heads) && this.props.heads.length > 0) {
    //             const lastHead = this.props.heads[this.props.heads.length - 1];
    //         }

    //         this.setState({
    //             headName: "",
    //             sequenceNo: this.props.headsLength ? this.props.headsLength + 1 : 1,
    //             headImage: "",
    //         });
    //     }
    //     if (this.props.headsLength && (this.props.headsLength !== prevProps.headsLength)) {
    //         this.setState({
    //             sequenceNo: this.props.headsLength + 1
    //         });
    //     }
    //     if (!this.props.edit && this.props.open && !prevProps.open) {
    //         let allImage = "";
    //         if (Array.isArray(this.props.heads) && this.props.heads.length > 0) {
    //             const lastHead = this.props.heads[this.props.heads.length - 1];
    //             if (lastHead && lastHead.allImage) {
    //                 allImage = lastHead.allImage;
    //             }
    //         }
    //         this.setState({
    //             headName: "",
    //             sequenceNo: this.props.headsLength ? this.props.headsLength + 1 : 1,
    //             headImage: "",
    //             allImage
    //         });
    //     }
    // }

    componentDidUpdate(prevProps) {
        if (
            this.props.edit &&
            (this.props.edit !== prevProps.edit) &&
            this.props.data.name
        ) {
            this.setState({
                headName: this.props.data.name,
                sequenceNo: this.props.data.sequence,
                headImage: this.props.data.headImage || "",
            });
        }
        if (!this.props.edit && this.props.open && !prevProps.open) {
            this.setState({
                headName: "",
                sequenceNo: this.props.headsLength
                    ? this.props.headsLength + 1
                    : 1,
                headImage: "",
            });
        }
        if (
            this.props.headsLength &&
            (this.props.headsLength !== prevProps.headsLength)
        ) {
            this.setState({
                sequenceNo: this.props.headsLength + 1
            });
        }
    }

    render() {
        const { classes } = this.props;
        return (
            <Modal
                className={classes.modal}
                open={this.props.open}
                closeAfterTransition
            >
                <div className={classes.modalContainer}>
                    <Grid container className={classes.header} spacing={1}>
                        <Grid item xs={8}>
                            <Typography variant="h5" gutterBottom>
                                Head
                            </Typography>
                        </Grid>
                        <Grid item xs={4}>
                            <CloseIcon className={classes.headGridTwo} onClick={() => { this.close() }} />
                        </Grid>
                    </Grid>
                    <Grid container className={classes.grid} spacing={2} style={{ marginTop: "10px" }}>
                        <Grid item xs={12}>
                            <Typography variant="subtitle2" gutterBottom>
                                Head Name*
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <TextField fullWidth margin="dense" name="headName" variant="outlined" value={this.state.headName} error={!!this.state.error} helperText={this.state.error} onChange={this.handleChange} />
                        </Grid>
                        <Grid item xs={12} style={{ marginTop: 10 }}>
                            <Typography variant="subtitle2">Head Image</Typography>
                            <input type="file" accept="image/*" onChange={this.handleHeadImageChange} disabled={this.state.uploading} />
                            {this.state.headImage && (
                                <div style={{ position: 'relative', display: 'inline-block', marginTop: 5 }}>
                                    <img src={this.state.headImage} alt="Head" style={{ maxWidth: 200, display: 'block' }} />
                                    <IconButton
                                        aria-label="delete"
                                        onClick={this.handleDeleteHeadImage}
                                        style={{
                                            position: 'absolute',
                                            top: 0,
                                            right: 0,
                                            backgroundColor: 'rgba(255, 255, 255, 0.8)',
                                            padding: '4px'
                                        }}
                                    >
                                        <DeleteIcon fontSize="small" />
                                    </IconButton>
                                </div>
                            )}
                        </Grid>
                        <Divider style={{ width: '100%', margin: '16px 0' }} />
                        <Grid item xs={6}>
                            <Button
                                style={{ margin: "5px" }}
                                fullWidth
                                variant="contained"
                                onClick={this.close}
                            >
                                Cancel
                            </Button>
                        </Grid>
                        <Grid item xs={6}>
                            <Button
                                fullWidth
                                style={{ margin: "5px" }}
                                variant="contained"
                                color="primary"
                                onClick={() => this.createHead()}
                                disabled={this.state.uploading}
                            >
                                SAVE
                            </Button>
                        </Grid>
                    </Grid>
                </div>
            </Modal>
        );
    }
}
const mapStateToProps = (state) => {
    return {
        dashboard: state.dashboard,
        business: state.business,
        contract: state.contract,
        user: state.auth.user,
        env: state.auth.env,
    };
};

export default connect(mapStateToProps, {
    addHeadSubhead,
    getHeadSubheadHierarchy,
    updateHeadAndSubhead,
})(withStyles(styles)(HeadDetailView));
